
import Checkbox from '@mui/material/Checkbox';
import * as yup from 'yup';
import consts from '../consts';
import Model from '../models/model';
import util from '../util';
import CatAdminForm from '../views/forms/CatAdminForm';
import { dataStore } from '../Store';
import { useGridBase } from '../components/grid/GridBaseContext';
import { syncFieldTests , fetchUserSyncDeviceType, userLogColumns } from './UserSyncTable';

const { adminModuleUserType } = consts;

const limitedRoles = ['supervisor', 'operator'];

const isLimitedUser = () => {
	const { auth } = dataStore.getState()
	const RoleName = auth?.tags?.RoleName;
	return limitedRoles.includes(RoleName?.toLowerCase())
}
const { isGridReadOnly, viewOnly, canAdd, canModify, deviceTypeRenderr, isFromTrackingSystem, isVisible } = util;
const { selectedUserSyncDeviceType } = consts;
const filter = [{ "operator": "$not", "property": "UserType", "value": 'Physician', type: 'string' }, { "operator": "$not", "property": "UserType", "value": 'Assistant', type: 'string' }];

const onNewHideColumn = ({ formik }) => {
	return Boolean(formik?.values?.Id);

}

const CustomCheckBox = ({ row }) => {
	const { rowSelectionModel, onRowSelectionModel } = useGridBase();
	const handleOnClick = () => {
		const result = Array.from(rowSelectionModel.ids).find(item => item === row._id);
		if (result) {
			const updatedRowSelectionModel = Array.from(rowSelectionModel.ids).filter(item => item !== row._id);
			onRowSelectionModel({ ...rowSelectionModel, ids: new Set(updatedRowSelectionModel) });
		}
		else {
			rowSelectionModel.ids.add(row._id);
			onRowSelectionModel(rowSelectionModel);
		}
	}

	const handleChecked = () => {
		return Array.from(rowSelectionModel.ids).some(item => item === row._id);
	}

	return (
		<Checkbox
			checked={handleChecked()}
			onClick={handleOnClick}
			disabled={viewOnly()}
			color="primary"
			value={row?.id}
			inputProps={{ 'aria-label': 'checkbox' }}
		/>
	)
}



const defaultUsername = ({ formik, values }) => {
	const { setFieldValue } = formik;
	if ((!formik.touched.UserName || values.UserName === '') && !values.id) {
		setFieldValue('UserName', `${values?.FirstName || ''}${values?.LastName || ''}`);
		if (values.UserName === '' && formik.touched.UserName) {
			formik.setFieldTouched('UserName', false)
		}
	}
}


const model = new Model({
	name: 'EndoSetupUser',
	title: 'EndoSetupUser',
	defaultSort: 'UserName ASC',
	disableAdd: canAdd,
	readOnly: isGridReadOnly,
	allowImport: canModify,
	disableDelete: true,
	disablePrintBarcode: false,
	disableSelectAll: false,
	idProperty: '_id',
	isAddRemove: false,
	disableExport: false,
	customeErrorOnSubmit: true,
	filter,
	showGridRefreshBtn: true,
	initialValues: {
		UserType: ''
	},
	importProps: { message: "UserCountWarning", maxCount: consts.maxUserCount, logColumns: userLogColumns, fileType: consts.endoImportSpec.EndoSetupUsers.fileType, type: consts.endoImportSpec.EndoSetupUsers.type },
	FormExtension: ({ formik, activeRecord, modelConfig, isNew }) => {
		return (
			<CatAdminForm activeRecord={activeRecord} formik={formik} modelConfig={modelConfig}
				isItemSync={false}
				isNew={isNew}
			/>
		)
	},
	formGroups: [{
		fields: ["CreatedOn", "ModifiedOn", "LastResyncOn", "DataSource", "Codes",
			"UserUID", "UserName", "FirstName", "LastName", "UserType",
			"IsActive", "ReSync", "InterFacedYN", "EquipmentName", "DeviceTypes", "UserCodes"]
	}],
	customizeSaveData: (toSave, { values, activeRecord }) => {
		toSave.RemoveCodes = JSON.stringify(values?.RemoveCodes || []);
		toSave.Parameters = JSON.stringify(activeRecord?.record?.Parameters || []);
		toSave.UserCodes = JSON.stringify(values?.UserCodes || []);
		toSave.UserType = values.UserType || '';
		return toSave;
	},
	gridTitle: 'EndoSetupUser',
	columns: [
		{ header: 'UserId', field: 'UserUID', width: 120, hidden: true, isNotformfield: true },
		{ field: 'UserName', width: 120, required: true, inputProps: { autoFocus: false }, readOnly: isFromTrackingSystem },
		{ field: 'FirstName', width: 120, onChange: defaultUsername, eager: true, readOnly: isFromTrackingSystem },
		{ field: 'LastName', width: 120, onChange: defaultUsername, eager: true, readOnly: isFromTrackingSystem },
		{ field: 'UserType', width: 120, lookup: 'UserGroups', defaultValue: 'Operators', readOnly: isFromTrackingSystem },
		{ field: 'CodesCount', header: 'BarcodeCount', width: 120, isNotformfield: true, type: 'string', hidden: true },
		{ header: 'Active', field: 'IsActive', type: 'bool', defaultValue: true, width: 120, readOnly: isFromTrackingSystem },
		{ header: 'DateDeActivated', field: 'DateDeActivated', type: 'date', width: 120, isLocal: true, format: 'MM/DD/YYYY hh:mm:ss A', hidden: true, readOnly: isFromTrackingSystem },
		{ field: 'ReSync', type: 'bool', width: 120, hidden: true, inputWhen: onNewHideColumn, readOnly: isFromTrackingSystem, defaultValue: true },
		{ field: 'DataSource', width: 220, readOnly: true, inputWhen: onNewHideColumn, hidden: true },
		{ header: 'DefaultBarcode', field: 'DefaultBarcode', width: 150 },
		{ header: 'DefaultRFID', field: 'DefaultRFID', hidden: true, width: 150 },
		{ header: 'updatedAt', field: 'ModifiedOn', width: 200, isLocal: true, type: 'date', readOnly: true, format: 'MM/DD/YYYY hh:mm:ss A', inputWhen: onNewHideColumn, },
		{ header: 'DateCreated', field: 'CreatedOn', width: 200, isLocal: true, type: 'date', format: 'MM/DD/YYYY hh:mm:ss A', hidden: true, readOnly: true, inputWhen: onNewHideColumn },
		{ header: 'LastResyncOn', field: 'LastResyncOn', width: 120, type: 'date', hidden: true, readOnly: true, format: 'MM/DD/YYYY hh:mm:ss A', inputWhen: onNewHideColumn, isLocal: true },
		{
			header: 'Codes', field: 'UserCodes', width: 100, hidden: true,
			validate: yup.array().of(
					yup.object().shape({
						CodeType: yup.string().required(),
						Code: yup.string(),
						IsActive: yup.boolean(),
						DefaultValue: yup.boolean(),
						RFIDTagNumber: yup.string(),
						RFIDEquipmentID: yup.string()
					})
				)
				.test(syncFieldTests.DuplicateBarcodeFound)
				.test(syncFieldTests.AtLeastOneBarcodeisRequired)
				.test(syncFieldTests.AtLeastOneDefaultBardcodeisRequired)
				.test(syncFieldTests.OverDefaultBarcodeFound)
				.test(syncFieldTests.CodeisRequired)
				.test(syncFieldTests.CodeLengthMax100)
				.test(syncFieldTests.DuplicateISARFIDFound)
				.test(syncFieldTests.DuplicateRapidRFIDTagFound)
				.test(syncFieldTests.ValidateRFIDTagNumberHex)
				.test(syncFieldTests.validateRFIDTagNumberFormat()),
			excludeOnGrid: true,
			isNotExportField: true,
			isNotformfield: true
		},
		{
			header: 'Parameters', field: 'Parameters', width: 220, hidden: true, lookup: 'UserSyncParameters', type: 'object', validate: yup.array().of(
				yup.object().shape({
					Key: yup.string().required(),
					Value: yup.string()
				})
			),
			excludeOnGrid: true,
		},
		{ header: 'DeviceTypes', field: 'DeviceTypes', hidden: true, width: 120, lookup: fetchUserSyncDeviceType, defaultValue: selectedUserSyncDeviceType, multiple: true, type: 'object', valueGetter: deviceTypeRenderr, readOnly: isFromTrackingSystem, inputWhen: isVisible },
		{ header: 'PrintBarcode', field: 'Print', type: 'action', filterable: false, width: 120, renderCell: CustomCheckBox, isNotExportField: true },

	],
	extraExportConfig: {
		PDF: {
			pageSize: 'A2'
		}
	}
});

export default model.createFormBase();
